import { AlertCircle, RefreshCw, Home } from "lucide-react";
import { Button } from "../";
import "./ErrorBoundary.css";

interface ErrorPageProps {
  error: Error | null;
  onReset: () => void;
}

const ErrorPage = ({ error, onReset }: ErrorPageProps) => {
  const handleGoHome = () => {
    onReset();
    // Use window.location instead of navigate since ErrorBoundary is outside Router
    window.location.href = "/dashboard";
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-page-container">
        <div className="error-page-icon">
          <AlertCircle size={64} strokeWidth={1.5} />
        </div>
        
        <h1 className="error-page-title">Something went wrong</h1>
        
        <p className="error-page-message">
          We're sorry, but something unexpected happened. Please try refreshing the page or return to the dashboard.
        </p>

        {error && process.env.NODE_ENV === "development" && (
          <div className="error-page-details">
            <p className="error-page-error-title">Error Details (Development Only):</p>
            <pre className="error-page-error-message">{error.toString()}</pre>
            {error.stack && (
              <details className="error-page-stack">
                <summary>Stack Trace</summary>
                <pre>{error.stack}</pre>
              </details>
            )}
          </div>
        )}

        <div className="error-page-actions">
          <Button
            variant="primary"
            onClick={handleGoHome}
            icon={Home}
            iconAlt="Home"
          >
            Go to Dashboard
          </Button>
          <Button
            variant="ghost"
            onClick={handleReload}
            icon={RefreshCw}
            iconAlt="Reload"
          >
            Reload Page
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

